/* app/ui/form/form.umbraco */

define(
	'app/ui/form/form.umbraco',[
		'jquery'
	],
	function($) {

		'use strict';

		return {
			init: function() {
				var $umbracoForms = $('.js-umbraco-form');

				if ($umbracoForms.length) {
					require(
						[
							'moment',
							'pikaday',
							'validate',
							'validateUnobtrusive'
						],
						function(moment, Pikaday) {
							require(
								[
									'umbracoForms10'
								],
								function() {
									var $datepickers = $('.js-umbraco-form .datepickerfield');
									if ($datepickers.length) {
										$datepickers.each(function() {
											new Pikaday({ field: this, yearRange: 10 });
										});
									}

									//code for member contact us form autofill
									var $autoField = $('.js-autofill-field');
									if ($autoField.length) {
										$autoField.each(function() {
											var $item = $(this);
											var fieldLabel = $item.attr('data-field');
											var fieldValue = $item.text();
											var $umbracoFormField = $umbracoForms.find('.' + fieldLabel);

											if ($umbracoFormField.length && $umbracoFormField.find('input').length) {
												$umbracoFormField.find('input').val(fieldValue);
											}
										});
									}
								});
						}
					);
				}
			}
		};
	}
);
